/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2025 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
"use strict";Object.defineProperty(exports,Symbol.toStringTag,{value:"Module"});const D="data-windowid",A=10002,I=2,S=".k-window:not(.k-dialog), .k-dialog-wrapper";exports.DATA_DIALOGS_ID=D;exports.DEFAULT_DIALOGS_ZINDEX=A;exports.DIALOGS_SELECTOR=S;exports.ZINDEX_DIALOGS_STEP=I;
